import React, { useState, useEffect } from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Button,
  Select,
  Textarea,
  VStack,
  useToast,
} from '@chakra-ui/react';

const AddJobPage = ({ jobToEdit, onSubmit, isLoading }) => {
  const toast = useToast();
  const [title, setTitle] = useState(jobToEdit ? jobToEdit.title : '');
  const [company, setCompany] = useState(jobToEdit ? jobToEdit.company : '');
  const [type, setType] = useState(jobToEdit ? jobToEdit.type : 'Full-time');
  const [location, setLocation] = useState(jobToEdit ? jobToEdit.location : '');
  const [salaryRange, setSalaryRange] = useState(jobToEdit ? jobToEdit.salaryRange : '');
  const [description, setDescription] = useState(jobToEdit ? jobToEdit.description : '');
  const [skills, setSkills] = useState(jobToEdit ? jobToEdit.skills.join(', ') : '');

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    // Validation for mandatory fields
    if (!title || !company || !type || !location || !salaryRange || !description || !skills) {
      toast({
        title: 'All fields are required',
        description: 'Please fill out all the fields.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    const jobData = {
      title,
      company,
      type,
      location,
      salaryRange,
      description,
      skills: skills.split(',').map((skill) => skill.trim()),
    };

    onSubmit(jobData);
  };

  useEffect(() => {
    if (jobToEdit) {
      setTitle(jobToEdit.title);
      setCompany(jobToEdit.company);
      setType(jobToEdit.type);
      setLocation(jobToEdit.location);
      setSalaryRange(jobToEdit.salaryRange);
      setDescription(jobToEdit.description);
      setSkills(jobToEdit.skills.join(', '));
    }
  }, [jobToEdit]);

  return (
    <Box as="form" onSubmit={handleSubmit} p={6} borderRadius="lg" boxShadow="md">
      <VStack spacing={4} align="stretch">
        <FormControl id="title" isRequired>
          <FormLabel>Job Title</FormLabel>
          <Input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Enter job title"
          />
        </FormControl>

        <FormControl id="company" isRequired>
          <FormLabel>Company</FormLabel>
          <Input
            type="text"
            value={company}
            onChange={(e) => setCompany(e.target.value)}
            placeholder="Enter company name"
          />
        </FormControl>

        <FormControl id="type" isRequired>
          <FormLabel>Job Type</FormLabel>
          <Select
            value={type}
            onChange={(e) => setType(e.target.value)}
            placeholder="Select job type"
          >
            <option value="Full-time">Full-time</option>
            <option value="Contract">Contract</option>
            <option value="Part-time">Part-time</option>
          </Select>
        </FormControl>

        <FormControl id="location" isRequired>
          <FormLabel>Location</FormLabel>
          <Input
            type="text"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            placeholder="Enter location"
          />
        </FormControl>

        <FormControl id="salaryRange" isRequired>
          <FormLabel>Salary Range</FormLabel>
          <Input
            type="text"
            value={salaryRange}
            onChange={(e) => setSalaryRange(e.target.value)}
            placeholder="Enter salary range"
          />
        </FormControl>

        <FormControl id="description" isRequired>
          <FormLabel>Description</FormLabel>
          <Textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Enter job description"
            size="lg"
          />
        </FormControl>

        <FormControl id="skills" isRequired>
          <FormLabel>Skills</FormLabel>
          <Input
            type="text"
            value={skills}
            onChange={(e) => setSkills(e.target.value)}
            placeholder="Enter skills, separated by commas"
          />
        </FormControl>

        <Button
          type="submit"
          colorScheme="teal"
          isLoading={isLoading}
          loadingText={jobToEdit ? 'Updating' : 'Adding'}
        >
          {jobToEdit ? 'Update Job' : 'Add Job'}
        </Button>
      </VStack>
    </Box>
  );
};

export default AddJobPage;
